

/**
 * 获取星级等级配置数据
 * @param {Object} apiClient - API客户端实例
 * @returns {Promise<Array>} 星级配置数据数组
 */
export const fetchStarLevels = async (apiClient) => {
  if (!apiClient) {
    console.warn('API客户端未初始化');
    return [];
  }
  
  // 先尝试从localStorage获取缓存数据
  try {
    const cachedData = localStorage.getItem('STAR_LEVEL');
    console.log('星级缓存数据:', cachedData);
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      console.log('解析后的星级数据:', parsedData);
      // 验证数据格式
      if (Array.isArray(parsedData) && parsedData.length > 0) {
        return parsedData;
      }
    }
  } catch (err) {
    console.error('读取星级缓存失败:', err);
  }
  
  // 缓存没有或无效，调用API获取数据
  try {
    const resp = await apiClient.post('/portal-server-prod/sys/enumconfig/v1/list', {
      tableName: 'STAR_LEVEL',
      colName: 'STAR_LEVEL',
    });
    
    if (resp.data && resp.data.code === 200) {
      let rawData = resp.data.data;
      if (typeof rawData === 'string') {
        rawData = JSON.parse(rawData);
      }
      
      // 构建选项，同时保留remark字段
      const levels = (rawData || []).map((item) => ({
        enumCode: item.enumCode || item.enumName,
        enumLabel: item.enumName,
        remark: item.remark || '', // 添加remark字段
      }));
      
      // 缓存到localStorage
      localStorage.setItem('STAR_LEVEL', JSON.stringify(levels));
      
      return levels;
    } else {
      console.error('获取星级列表失败:', resp.data?.msg || '未知错误');
      return [];
    }
  } catch (error) {
    console.error('获取星级列表异常:', error);
    return [];
  }
};

/**
 * 根据星级获取课时费
 * @param {string} starLevel - 星级名称
 * @param {Array} starLevels - 星级配置数据
 * @returns {number|null} 课时费，如果找不到则返回null
 */
export const getClassHourPrice = (starLevel, starLevels) => {
  if (!starLevel) {
    return null;
  }
  
  // 如果starLevels为空数组或不是数组，返回null
  if (!Array.isArray(starLevels) || starLevels.length === 0) {
    console.warn('星级配置数据为空，starLevel:', starLevel, 'starLevels:', starLevels);
    return null;
  }
  
  const level = starLevels.find(item => item.enumCode === starLevel);
  if (!level || !level.remark) {
    return null;
  }
  
  try {
    const remark = JSON.parse(level.remark);
    return remark.chp || null;
  } catch (err) {
    console.error('解析remark字段失败:', err);
    return null;
  }
};

/**
 * 判断当前用户是否有管理员权限
 * @returns {boolean} 是否为管理员(R00001角色)
 */
export const isAdminUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return false;
    
    const user = JSON.parse(userStr);
    return user.role === 'R00001';
  } catch (err) {
    console.error('解析用户信息失败:', err);
    return false;
  }
};